'use client';

import { ChakraProvider } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

import system from '../../theme/chakraTheme';

export {
  Box,
  Flex,
  Text,
  Stack,
  HStack,
  VStack,
  Button,
  IconButton,
  Image,
  Input,
  Card,
  Link,
  Heading,
  Spinner,
  Avatar,
  Icon,
  Badge,
  InputGroup,
  Grid,
  useBreakpointValue,
  // Notification Bell (#805025) — the single overlay primitive shared by the desktop dropdown
  // and the mobile full-screen view (responsive `placement`/`size`, see `NotificationBellPanel`).
  // Not used anywhere else in this repo or the Design-System-Module yet.
  Drawer,
  Portal,
} from '@chakra-ui/react';

export const Provider: React.FC<PropsWithChildren> = ({ children }) => (
  <ChakraProvider value={system}>{children}</ChakraProvider>
);
